export const FLAG_GETTING_SEGMENTS = 'FLAG_GETTING_SEGMENTS';
export const GET_SEGMENTS = 'GET_SEGMENTS';
export const CLEAR_SEGMENTS = 'CLEAR_SEGMENTS';
export const FLAG_SEGMENT_ACTIVITY = 'FLAG_SEGMENT_ACTIVITY';
export const GET_SEGMENT = 'GET_SEGMENT';
export const CLEAR_SEGMENT = 'CLEAR_SEGMENT';
